import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zulip = defineConnector({
  identifier: "zulip",
  name: "Zulip",
  tagLine: "Organized team chat",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://.*\\.zulipchat\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.email,
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get your Zulip server URL",
      items: [
        {
          kind: "markdown",
          content:
            "Enter your Zulip server URL. For Zulip Cloud, this is typically `https://yourorg.zulipchat.com`. For self-hosted instances, enter your server's URL.",
        },
        {
          kind: "url",
          label: "Server URL",
          placeholder: "https://yourorg.zulipchat.com",
          required: true,
          target: { kind: "configuration", field: "serverUrl" },
        },
      ],
    },
    {
      title: "Generate an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to your Zulip settings (gear icon → Personal settings → Account & privacy) and click **Generate API key**. You'll need your email address and the generated API key.",
        },
        {
          kind: "input",
          label: "Email",
          placeholder: "you@example.com",
          required: true,
          target: { kind: "configuration", field: "email" },
        },
        {
          kind: "input",
          label: "API key",
          placeholder: "Your Zulip API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) => ({
      url: `${serverUrl}/api/v1/users/me`,
      expectedStatus: 200,
    }),
  },
  publicEnvVars: ({ serverUrl }) => ({
    ZULIP_URL: serverUrl || "",
  }),
});
